module.exports = __webpack_public_path__ + "static/media/AiAnimation.cff185e9.webp";